import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../videosAssignmentState/videosAssignmentContext';
import { RequestEntity } from 'types';
import { AssignImg } from 'components/AssignImg/AssignImg';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Customers.module.scss';

const Customers: React.FC = () => {
	const { setIDsSelectedCustomers, allCustomers, searchStringForAllCustomers, IDsSelectedCustomers } =
		useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const filteredAllCustomers = useMemo(() => {
		return searchStringForAllCustomers
			? allCustomers.filter((el) => el.name?.toLowerCase().includes(searchStringForAllCustomers.toLowerCase()))
			: allCustomers;
	}, [searchStringForAllCustomers, allCustomers]);

	const handleChange = (isChecked: boolean, customerID: string) => {
		if (isChecked) {
			const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
			copyIDsSelectedCustomers[customerID] = true;
			setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
		} else {
			const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
			delete copyIDsSelectedCustomers[customerID];
			setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
		}
	};

	return (
		<div className={style.container} data-test="Customers">
			{filteredAllCustomers.map((el) => {
				const isChecked = el.id in IDsSelectedCustomers;
				const isHaveVideos = el.hasVideos;
				const itemClasses = classNames(style.item, {
					[style.assign]: isHaveVideos,
					[style.isChecked]: isChecked,
				});

				return (
					<div className={itemClasses} key={el.id + 'mainDisplayCustomersTab'}>
						<div className={style.imageWrapper}>
							<ImgUploaderByEntityId
								resource={RequestEntity.Customers}
								entityID={el.filePath ? el.id : ''}
								photoSize="Small"
								loaderSize="small"
								noImageIdIcon="customerDefaultAvatar"
							/>
							{isHaveVideos ? <AssignImg name="assignedVideoLabel" /> : null}
						</div>
						<div className={style.name}>
							<Checkbox
								className={style.checkbox}
								onChange={(e) => handleChange(e.target.checked, el.id)}
								checked={isChecked}
							/>
							<Text translationKey={el.name} withTooltip={true} />
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Customers;
